export default "__VITE_ASSET__eEqt4RlA__"